<template>
   <LoadingPage v-if="isLoading"></LoadingPage>

   <div class="card">
      <div class="card-body m-2">
         <div class="row p-2 align-items-center">
            <div class="col-12 col-lg-4 mb-2 mb-lg-0">
               <div class="search-input-wrapper">
                  <input v-model.trim="search" type="text" class="form-control form-control-sm search-input"
                     placeholder="🔍 Search contact name, role, or organisation..."
                     @keyup="onSearch()" />
                  <button v-if="search.length > 0" type="button" class="search-clear-btn" @click="search = ''; onSearch()">
                     <i class="fa-solid fa-xmark"></i>
                  </button>
               </div>
            </div>

            <div v-if="$store.getters['auth/canEditContentLibrary']" class="col-12 col-lg-auto d-flex mb-2 mb-lg-0">
               <button type="button" class="fw-bold btn btn-info text-light btn-sm"
                  style="font-size: 14px; height: 40px; border-radius: 8px !important; padding: 0 1.5rem;" data-bs-toggle="modal"
                  data-bs-target="#testimonialForm" @click="onButtonClick('create')">
                  Create Testimonial
               </button>
            </div>

            <div class="col-12 col-lg d-flex flex-wrap justify-content-lg-end align-items-center">
               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Sort By:</span>
                  <select v-model="sortBy" class="form-select shadow-none filterOptions bordered-select">
                     <option v-for="sortByItem in sortByList" :value="sortByItem.value" :key="sortByItem.value">
                        {{ sortByItem.text }}
                     </option>
                  </select>
               </div>

               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Rows per page:</span>
                  <select v-model="pagination.pageSize"
                     class="form-select form-select-sm shadow-none filterOptions bordered-select">
                     <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">
                        {{ row.text }}
                     </option>
                  </select>
               </div>

               <div class="pagination">
                  <button @click="previousPage()" :disabled="pagination.page === 1" class="pagination-arrow">
                     <i class="fas fa-chevron-left"></i>
                  </button>
                  <span class="pagination-label">
                     <strong>{{ paginationLabel }}</strong> of {{ pagination.totalItems }}
                  </span>
                  <button @click="nextPage()"
                     :disabled="pagination.page === pagination.totalPages || pagination.totalItems == 0"
                     class="pagination-arrow">
                     <i class="fas fa-chevron-right"></i>
                  </button>
               </div>
            </div>
         </div>

         <!-- Filters Section -->
         <div class="row p-2 pt-0 align-items-center">
            <div class="col-12 d-flex flex-wrap align-items-center gap-2">
               <!-- Type Filter Dropdown -->
               <div class="dropdown">
                  <button type="button" class="btn custom-filter-dropdown-btn btn-sm fw-bold"
                     style="height: 35px; border-radius: 8px !important; display: inline-flex; align-items: center;"
                     data-bs-toggle="dropdown" aria-expanded="false">
                     Type
                     <i class="fa-solid fa-filter ms-2" style="font-size: 12px; color: #00A0C1;"></i>
                     <span v-if="typeFilter.length > 0" class="badge ms-2 rounded-pill text-white" style="font-size: 10px; background-color: #00A0C1 !important;">
                        {{ typeFilter.length }}
                     </span>
                  </button>
                  <div class="dropdown-menu p-2" style="min-width: 200px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" @click.stop>
                     <div class="d-flex flex-column gap-2 w-100" style="max-height: 250px; overflow-y: auto;">
                        <div v-for="opt in typeOptions" :key="opt.value" class="d-flex align-items-center mb-1">
                           <label class="d-flex align-items-center cursor-pointer mb-0 w-100">
                              <input class="custom-checkbox-input" type="checkbox" :id="'testimonial-type-' + opt.value" :value="opt.value" v-model="typeFilter">
                              <span class="custom-checkbox"></span>
                              <span class="ms-2 select-none" style="font-size: 14px; font-weight: 500; color: #495057;">{{ opt.text }}</span>
                           </label>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Organisation Filter Dropdown -->
               <div class="dropdown">
                  <button type="button" class="btn custom-filter-dropdown-btn btn-sm fw-bold"
                     style="height: 35px; border-radius: 8px !important; display: inline-flex; align-items: center;"
                     data-bs-toggle="dropdown" aria-expanded="false">
                     Organisation
                     <i class="fa-solid fa-filter ms-2" style="font-size: 12px; color: #00A0C1;"></i>
                     <span v-if="orgFilter.length > 0" class="badge ms-2 rounded-pill text-white" style="font-size: 10px; background-color: #00A0C1 !important;">
                        {{ orgFilter.length }}
                     </span>
                  </button>
                  <div class="dropdown-menu p-2" style="min-width: 250px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" @click.stop>
                     <div class="d-flex flex-column gap-2 w-100" style="max-height: 250px; overflow-y: auto;">
                        <div v-for="org in sortedOrganisations" :key="org.id" class="d-flex align-items-center mb-1">
                           <label class="d-flex align-items-center cursor-pointer mb-0 w-100">
                              <input class="custom-checkbox-input" type="checkbox" :id="'testimonial-org-' + org.id" :value="org.id" v-model="orgFilter">
                              <span class="custom-checkbox"></span>
                              <span class="ms-2 select-none" style="font-size: 14px; font-weight: 500; color: #495057;">{{ org.name }}</span>
                           </label>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Product Filter Dropdown -->
               <div class="dropdown">
                  <button type="button" class="btn custom-filter-dropdown-btn btn-sm fw-bold"
                     style="height: 35px; border-radius: 8px !important; display: inline-flex; align-items: center;"
                     data-bs-toggle="dropdown" aria-expanded="false">
                     Product
                     <i class="fa-solid fa-filter ms-2" style="font-size: 12px; color: #00A0C1;"></i>
                     <span v-if="productFilter.length > 0" class="badge ms-2 rounded-pill text-white" style="font-size: 10px; background-color: #00A0C1 !important;">
                        {{ productFilter.length }}
                     </span>
                  </button>
                  <div class="dropdown-menu p-2" style="min-width: 250px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" @click.stop>
                     <div class="d-flex flex-column gap-2 w-100" style="max-height: 250px; overflow-y: auto;">
                        <div v-for="prod in sortedProducts" :key="prod.id" class="d-flex align-items-center mb-1">
                           <label class="d-flex align-items-center cursor-pointer mb-0 w-100">
                              <input class="custom-checkbox-input" type="checkbox" :id="'testimonial-prod-' + prod.id" :value="prod.id" v-model="productFilter">
                              <span class="custom-checkbox"></span>
                              <span class="ms-2 select-none" style="font-size: 14px; font-weight: 500; color: #495057;">{{ prod.display_name }}</span>
                           </label>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Active Filters Chips -->
               <div v-if="typeFilter.length > 0 || orgFilter.length > 0 || productFilter.length > 0" class="d-flex flex-wrap gap-2 align-items-center ms-3">
                  <span class="small text-muted fw-bold">Active Filters:</span>
                  <!-- Type Chips -->
                  <span v-for="val in typeFilter" :key="'type-' + val" class="badge bg-info text-white p-2 d-inline-flex align-items-center gap-1" style="border-radius: 20px; font-size: 12px; font-weight: 500; background-color: #00A0C1 !important;">
                     {{ getTypeDisplayName(val) }}
                     <i class="fa-solid fa-xmark cursor-pointer ms-1" style="font-size: 10px;" @click="removeTypeFilter(val)"></i>
                  </span>
                  <!-- Org Chips -->
                  <span v-for="val in orgFilter" :key="'org-' + val" class="badge bg-info text-white p-2 d-inline-flex align-items-center gap-1" style="border-radius: 20px; font-size: 12px; font-weight: 500; background-color: #00A0C1 !important;">
                     {{ getOrgDisplayName(val) }}
                     <i class="fa-solid fa-xmark cursor-pointer ms-1" style="font-size: 10px;" @click="removeOrgFilter(val)"></i>
                  </span>
                  <!-- Product Chips -->
                  <span v-for="val in productFilter" :key="'prod-' + val" class="badge bg-info text-white p-2 d-inline-flex align-items-center gap-1" style="border-radius: 20px; font-size: 12px; font-weight: 500; background-color: #00A0C1 !important;">
                     {{ getProductDisplayName(val) }}
                     <i class="fa-solid fa-xmark cursor-pointer ms-1" style="font-size: 10px;" @click="removeProductFilter(val)"></i>
                  </span>
                  <button type="button" class="btn btn-link btn-sm text-decoration-none p-0 ms-2" style="font-size: 12px; color: #00A0C1;" @click="clearFilter()">Clear All</button>
               </div>
            </div>
         </div>
      </div>
   </div>

   <!-- Empty State -->
   <div v-if="!isLoading && testimonials.length < 1" class="testimonial-empty-state">
      <div class="empty-state-content">
         <div class="empty-state-icon">
            <i class="fa-solid fa-quote-left"></i>
         </div>
         <h4 class="empty-state-title">No testimonials yet</h4>
         <p class="empty-state-subtitle">Collect and showcase what your clients say about your products and services.</p>
         <button v-if="$store.getters['auth/canEditContentLibrary']" type="button" class="btn btn-info text-light fw-bold" style="border-radius: 8px; padding: 0.5rem 1.5rem;"
            data-bs-toggle="modal" data-bs-target="#testimonialForm" @click="onButtonClick('create')">
            <i class="fa-solid fa-plus me-2"></i>Create your first testimonial
         </button>
      </div>
   </div>

   <!-- Card Grid -->
   <TransitionGroup name="card-stagger" tag="div"
      class="mt-4 mb-2 testimonial-list row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4"
      appear>
      <div v-for="(testimonial, index) in testimonials" :key="testimonial.id" class="col"
         :style="{ animationDelay: (index * 60) + 'ms' }">
         <div class="card h-100 testimonial-card-new"
            :class="{ 'testimonial-card--video': isVideoTestimonial(testimonial) }"
            @click="onButtonClick('body-testimonial-tab', testimonial.id)"
            title="Click to view or edit testimonial">

            <!-- Type icon badge (top-left corner) -->
            <div class="type-icon-badge" :class="isVideoTestimonial(testimonial) ? 'type-icon--video' : 'type-icon--text'"
               :title="isVideoTestimonial(testimonial) ? 'Video Testimonial' : 'Text Testimonial'">
               <i :class="isVideoTestimonial(testimonial) ? 'fa-solid fa-video' : 'fa-solid fa-align-left'"></i>
            </div>

            <!-- Delete button (top-right corner) -->
            <button v-if="$store.getters['auth/isGlobalSuperAdmin']" type="button"
               class="card-delete-btn delete-testimonial-button"
               title="Delete testimonial" @click.stop="deleteTestimonial(testimonial.id)">
               <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="card-body d-flex flex-column text-center">
               <!-- Avatar with gradient ring -->
               <div class="avatar-wrapper" :class="{ 'avatar-wrapper--video': isVideoTestimonial(testimonial) }">
                  <img v-if="(testimonial.testimonial_image && testimonial.testimonial_image.full_link)"
                     class="avatar-img" :src="testimonial.testimonial_image.full_link" :alt="testimonial.contact_name">
                  <div v-else class="avatar-initials" :style="{ backgroundColor: getAvatarColor(testimonial.contact_name) }">
                     {{ getInitials(testimonial.contact_name) }}
                  </div>
               </div>

               <!-- Name & Role -->
               <h5 class="contact-name mt-3 mb-0">{{ testimonial.contact_name }}</h5>
               <p class="contact-role">{{ testimonial.contact_role }}</p>

               <!-- Organisation & Relative Date -->
               <div class="testimonial-meta">
                  <span class="meta-org">{{ GetOrganisationName(testimonial.organisation_id) }}</span>
                  <span class="meta-date" :title="formatDate(testimonial.date_created)">{{ relativeDate(testimonial.date_created) }}</span>
               </div>

               <!-- Quote Preview -->
               <div class="quote-preview" v-if="testimonial.testimonial && testimonial.testimonial !== ''">
                  <span class="quote-mark">"</span>{{ truncateQuote(testimonial.testimonial, 100) }}<span class="quote-mark">"</span>
               </div>
               <div class="quote-preview quote-preview--video" v-else>
                  <i class="fa-solid fa-play-circle me-1"></i> Video testimonial — click to view
               </div>

               <!-- Soft Product Tags (capped at 3) -->
               <div v-if="testimonial.products && testimonial.products.length > 0"
                  class="label-container justify-content-center mt-auto">
                  <span v-for="product in visibleProducts(testimonial.products)" :key="product.uuid" class="label">
                     {{ product.Product.display_name }}
                  </span>
                  <span v-if="testimonial.products.length > 3" class="label label--overflow overflow-trigger" @click.stop>
                     +{{ testimonial.products.length - 3 }} more
                     <div class="overflow-popover">
                        <span v-for="product in hiddenProducts(testimonial.products)" :key="product.uuid" class="label">
                           {{ product.Product.display_name }}
                        </span>
                     </div>
                  </span>
               </div>
            </div>
         </div>
      </div>
   </TransitionGroup>
   
   <div ref="testimonialModalRef" class="modal fade" id="testimonialForm" tabindex="-1" data-bs-keyboard="false"
      data-bs-backdrop="static" style="top: 0%;">
      <div ref="modalDialogRef" class="modal-dialog modal-dialog-scrollable">
         <div class="modal-content">
            <div class="modal-header justify-content-end">
               <div>
                  <button ref="closeModalActionForm" type="button" class="btn-close" data-bs-dismiss="modal"
                     aria-label="Close" @click="this.$refs.testimonialFormRef.resetForm()"></button>
               </div>
            </div>
            <div class="modal-body" style="overflow-y: scroll">
               <TestimonialForm ref="testimonialFormRef"
                  @onSubmit="this.getTestimonialList(); this.$refs.closeModalActionForm.click();" />
            </div>
         </div>
      </div>
   </div>

   <div class="offcanvas offcanvas-end" tabindex="-1" id="testimonialSidebar" aria-labelledby="testimonialSidebar"
      ref="testimonialSidebarRef" style="width:700px">
      <router-view ref="tetimonialViewRef" @onEditForm="hasBeenEdited()"></router-view>
   </div>

   <ConfirmModal
      v-model="showConfirmModal"
      :title="confirmModalTitle"
      :message="confirmModalMessage"
      @confirm="onConfirmAction"
   />
</template>

<script>
import { Offcanvas } from 'bootstrap';
import moment from 'moment';
import { debounce, truncateLongText } from '@/plugins/helper.js';
import TestimonialForm from '@/components/ContentLibrary/TestimonialForm.vue';
import LoadingPage from '@/components/Utilities/vertex-loading.vue';

export default ({
   components: {
      TestimonialForm,
      LoadingPage,
   },
   props: {
      organisationId: {},
      testimonialID: {}
   },
   data() {
      return {
         search: "",
         debounceFn: null,
         testimonials: [],
         organisations: [],
         pagination: {
            pageSize: 10,
            page: 1,
            totalItems: 0,
            totalPages: 1,
         },
         rowsPerPageList: [
            { text: "5", value: 5 },
            { text: "10", value: 10 },
            { text: "20", value: 20 },
         ],
         sortByList: [
            { text: "Date: Newest", value: "dateCreated_desc" },
            { text: "Date: Oldest", value: "dateCreated_asc" },
            { text: "Contact Name (A-Z)", value: "name_asc" },
            { text: "Contact Name (Z-A)", value: "name_desc" },
            { text: "Organisation (A-Z)", value: "organisation_asc" },
            { text: "Organisation (Z-A)", value: "organisation_desc" },
         ],
         sortBy: "dateCreated_desc",
         sorting: {
            field: "dateCreated",
            order: "desc"
         },
         typeFilter: [],
         orgFilter: [],
         productFilter: [],
         typeOptions: [
            { text: "Text Testimonials", value: "text" },
            { text: "Video Testimonials", value: "video" },
         ],
         isLoading: false,
         beenEdited: false,
         productList: [],
         isDeleteTestimonial: false,
         showConfirmModal: false,
         confirmModalTitle: '',
         confirmModalMessage: '',
         pendingDeleteId: null,
      }
   },
   computed: {
      paginationLabel() {
         var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
         var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)
         return start + " - " + end
      },
      currentPage() { return this.pagination.page },
      rowsPerPage() { return this.pagination.pageSize },
      sortItems() { return this.sortBy },
      currentOrg() { return this.organisationId },
      sortedOrganisations() {
         return [...this.organisations].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      },
      sortedProducts() {
         return [...this.productList].sort((a, b) => (a.display_name || '').localeCompare(b.display_name || ''))
      },
   },
   watch: {
      currentPage() { this.getTestimonialList() },
      rowsPerPage() {
         this.pagination.page = 1
         this.getTestimonialList()
      },
      sortItems() {
         if (this.sortBy.includes("_")) {
            let sort = this.sortBy.split("_")
            this.sorting.field = sort[0]
            this.sorting.order = sort[1]
         } else {
            this.sorting.field = this.sortBy
            this.sorting.order = ""
         }
         this.pagination.page = 1
         this.getTestimonialList()
      },
      currentOrg() { this.init() },
      typeFilter: {
         handler() {
            this.pagination.page = 1
            this.getTestimonialList()
         },
         deep: true,
      },
      orgFilter: {
         handler() {
            this.pagination.page = 1
            this.getTestimonialList()
         },
         deep: true,
      },
      productFilter: {
         handler() {
            this.pagination.page = 1
            this.getTestimonialList()
         },
         deep: true,
      },
   },
   created() {
      this.init()
      this.debounceFn = debounce(() => this.getTestimonialList(), 500)
   },
   mounted() {
      document.addEventListener('click', this.handleClickOutside);
   },
   beforeUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
   },
   methods: {
      handleClickOutside(event) {
         const isClickOnRemoveButton = event.target.classList.contains('removeFile');
         const isClickOnCanvas = event.target.classList.contains('delete-testimonial-button');
         if (
            this.$refs.modalDialogRef &&
            !this.$refs.modalDialogRef.contains(event.target) &&
            this.$refs.testimonialModalRef.classList.contains('show') &&
            !isClickOnRemoveButton && !isClickOnCanvas
         ) {
            const closeButton = this.$refs.closeModalActionForm;
            if (closeButton) {
               closeButton.click();
            }
         }
      },
      init() {
         this.getAuthOrganisations()
         this.getTestimonialList()
         this.getProductList()
      },
      formatDate(date) { return moment(date).format("DD-MMM-YYYY") },
      previousPage() { if (this.pagination.page > 1) { this.pagination.page--; } },
      nextPage() { if (this.pagination.page < this.pagination.totalPages) { this.pagination.page++; } },
      truncateLongText(text, limit) { return truncateLongText(text, limit) },
      GetOrganisationName(org_id) {
         const organisation = this.organisations.find(org => org.id === org_id);
         return organisation ? organisation.name : 'N/A';
      },
      getTypeDisplayName(val) {
         if (val === 'text') return 'Text'
         if (val === 'video') return 'Video'
         return val
      },
      getOrgDisplayName(val) {
         const org = this.organisations.find(o => o.id === val || o.id === parseInt(val, 10))
         return org ? org.name : `Org #${val}`
      },
      getProductDisplayName(val) {
         const prod = this.productList.find(p => p.id === val)
         return prod ? prod.display_name : val
      },
      removeTypeFilter(val) {
         this.typeFilter = this.typeFilter.filter(item => item !== val)
      },
      removeOrgFilter(val) {
         this.orgFilter = this.orgFilter.filter(item => item !== val)
      },
      removeProductFilter(val) {
         this.productFilter = this.productFilter.filter(item => item !== val)
      },
      clearFilter() {
         this.typeFilter = []
         this.orgFilter = []
         this.productFilter = []
      },
      onButtonClick(action, id) {
         if (action == "delete") {
            this.deleteTestimonial(id)
            return
         } else if (action == "testimonial-tab") {
            this.onToggleSidebar()
            this.$router.push({ name: 'testimonial-view', params: { id: id } })
         } else if (action == "body-testimonial-tab") {
            const testimonialOffcanvas = document.getElementById('testimonialSidebar');
            const offcanvasInstance = new Offcanvas(testimonialOffcanvas);
            offcanvasInstance.show();
            this.onToggleSidebar()
            this.$router.push({ name: 'testimonial-view', params: { id: id } })
         }
      },
      onSearch() {
         this.debounceFn()
         this.pagination.page = 1
      },
      async getAuthOrganisations() {
         await this.$axios_auth.get("/vertex/organisations")
            .then((response) => {
               this.organisations = response.data.organisations
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
      },
      async deleteTestimonial(id) {
         this.pendingDeleteId = id;
         this.confirmModalTitle = 'Delete Testimonial';
         this.confirmModalMessage = 'Do you want to delete this testimonial?';
         this.showConfirmModal = true;
      },
      async onConfirmAction() {
         const id = this.pendingDeleteId;
         this.pendingDeleteId = null;
         if (!id) return;
         this.isLoading = true
         this.isDeleteTestimonial = true
         await this.$axios.delete("/testimonials/" + id)
            .then((response) => {
               if (response.data.success) {
                  this.$toast.success(response.data.message)
                  this.getTestimonialList()
               } else {
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
            .finally(() => {
               this.isLoading = false
            })
      },
      async getTestimonialList() {
         this.isLoading = true;
         let apiPath = `/testimonials?pageSize=${this.pagination.pageSize}&page=${this.pagination.page}`
         if (this.sorting.field) {
            apiPath += `&sort=${this.sorting.field}`
            if (this.sorting.order != "") {
               apiPath += `&order=${this.sorting.order}`
            }
         }
         if (this.typeFilter && this.typeFilter.length > 0) {
            apiPath += `&type=${this.typeFilter.join(",")}`
         }
         if (this.orgFilter && this.orgFilter.length > 0) {
            apiPath += `&org=${this.orgFilter.join(",")}`
         }
         if (this.productFilter && this.productFilter.length > 0) {
            apiPath += `&product=${encodeURIComponent(this.productFilter.join(","))}`
         }
         if (this.search != "") {
            apiPath += `&search=${encodeURIComponent(this.search)}`
         }

         await this.$axios.get(apiPath)
            .then((response) => {
               this.testimonials = response.data.testimonials || []
               this.pagination.totalItems = response.data.total_items || 0
               this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
            })
            .catch((error) => {
               this.$toast.error(error.response?.data?.message || "Unable to get testimonials.")
            })
            .finally(() => {
               this.isLoading = false
            })
      },
      onToggleSidebar() {
         this.$refs.testimonialSidebarRef.addEventListener('hidden.bs.offcanvas', () => {
            if (this.beenEdited) {
               this.beenEdited = false
               this.getTestimonialList()
            }
            this.$router.push({ name: 'content_library_testimonials' })
         });
      },
      hasBeenEdited() { this.beenEdited = true },
      async getProductList() {
         await this.$axios.get("/categories?name=Products")
            .then((response) => {
               this.productList = response.data.category.subcategories.map(p => ({
                  id: p.id,
                  display_name: p.display_name
               }));
            })
            .catch((error) => {
               console.error(error)
               this.$toast.error(error.response.data.message)
            })
      },
      isVideoTestimonial(testimonial) {
         return !(testimonial.testimonial && testimonial.testimonial !== "");
      },
      getInitials(name) {
         if (!name) return '?';
         const parts = name.trim().split(/\s+/);
         if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
         }
         return parts[0].substring(0, 2).toUpperCase();
      },
      getAvatarColor(name) {
         if (!name) return '#6B7280';
         const colors = [
            '#0EA5E9', '#8B5CF6', '#EC4899', '#F59E0B',
            '#10B981', '#EF4444', '#6366F1', '#14B8A6',
            '#F97316', '#06B6D4'
         ];
         let hash = 0;
         for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
         }
         return colors[Math.abs(hash) % colors.length];
      },
      truncateQuote(text, limit) {
         if (!text) return '';
         if (text.length <= limit) return text;
         return text.substring(0, limit).trim() + '...';
      },
      visibleProducts(products) {
         return products.slice(0, 3);
      },
      hiddenProducts(products) {
         return products.slice(3);
      },
      relativeDate(date) {
         return moment(date).fromNow();
      },
   },
})
</script>

<style scoped>
/* --- Search Input --- */
.search-input-wrapper {
   position: relative;
   display: flex;
   align-items: center;
}
.search-input {
   border-radius: 8px !important;
   height: 40px;
   font-size: 14px;
   font-family: 'Roboto', sans-serif;
   font-weight: 400;
   padding-left: 12px !important;
   padding-right: 36px !important;
}
.search-clear-btn {
   position: absolute;
   right: 8px;
   background: none;
   border: none;
   color: #9CA3AF;
   cursor: pointer;
   padding: 4px 8px;
   font-size: 14px;
   z-index: 2;
   transition: color 0.2s ease;
}
.search-clear-btn:hover {
   color: #EF4444;
}

/* --- Nav Bar Styles --- */
.filterTitle {
   font-weight: 500;
   color: #435666;
}
.filterOptions {
   font-weight: 500;
   color: #00A0C1;
}
.bordered-select {
   border: 1px solid #dee2e6 !important;
   border-radius: 8px !important;
   padding-top: 0.25rem;
   padding-bottom: 0.25rem;
   padding-left: 0.75rem;
   width: auto;
}
.pagination {
    display: inline-flex;
    align-items: center;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
}
.pagination-label {
    font-size: 0.9rem;
    color: #6c757d;
    font-weight: 500;
    padding: 0 8px;
    white-space: nowrap;
}
.pagination-label strong {
    color: #343a40;
}
.pagination-arrow {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #00A0C1;
    font-size: 1rem;
    padding: 8px 12px;
    transition: background-color 0.2s ease;
}
.pagination-arrow:hover:not(:disabled) {
    background-color: #f1f3f5;
}
.pagination-arrow:disabled {
    color: #ced4da;
    cursor: not-allowed;
}

/* --- Empty State --- */
.testimonial-empty-state {
   display: flex;
   justify-content: center;
   align-items: center;
   min-height: 320px;
   margin-top: 2rem;
}
.empty-state-content {
   text-align: center;
   max-width: 400px;
}
.empty-state-icon {
   width: 80px;
   height: 80px;
   border-radius: 50%;
   background: linear-gradient(135deg, #E0F7FA 0%, #B2EBF2 100%);
   display: flex;
   align-items: center;
   justify-content: center;
   margin: 0 auto 1.25rem;
}
.empty-state-icon i {
   font-size: 2rem;
   color: #00A0C1;
}
.empty-state-title {
   font-weight: 700;
   color: #343a40;
   margin-bottom: 0.5rem;
}
.empty-state-subtitle {
   color: #6c757d;
   font-size: 0.95rem;
   margin-bottom: 1.5rem;
   line-height: 1.5;
}

/* --- Card Styles --- */
.testimonial-card-new {
   background-color: #fff;
   border: 1px solid #E5E7EB;
   border-radius: 14px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
   transition: transform 0.25s ease, box-shadow 0.25s ease;
   cursor: pointer;
   position: relative;
   overflow: visible;
   border-top: 3px solid #00A0C1;
}
.testimonial-card--video {
   border-top-color: #8B5CF6;
}
.testimonial-card-new:hover {
   transform: translateY(-4px);
   box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1);
}
.testimonial-card-new .card-body {
   padding: 50px 16px 16px 16px;
   position: relative;
}

/* --- Type Icon Badge (top-left corner) --- */
.type-icon-badge {
   position: absolute;
   top: 10px;
   left: 10px;
   width: 28px;
   height: 28px;
   border-radius: 8px;
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 0.7rem;
   z-index: 2;
}
.type-icon--text {
   background-color: #E0F7FA;
   color: #00838F;
}
.type-icon--video {
   background-color: #EDE9FE;
   color: #7C3AED;
}

/* --- Card Delete Button (top-right) --- */
.card-delete-btn {
   position: absolute;
   top: 8px;
   right: 8px;
   width: 28px;
   height: 28px;
   border-radius: 50%;
   border: 1px solid #E5E7EB;
   background: #F3F4F6;
   color: #9CA3AF;
   font-size: 0.9rem;
   display: flex;
   align-items: center;
   justify-content: center;
   cursor: pointer;
   z-index: 2;
   transition: all 0.2s ease;
}
.card-delete-btn:hover {
   background: #FEE2E2;
   color: #DC2626;
   border-color: #FECACA;
}

/* --- Avatar --- */
.avatar-wrapper {
   position: absolute;
   top: -36px;
   left: 50%;
   transform: translateX(-50%);
   border-radius: 50%;
   padding: 4px;
   background: linear-gradient(135deg, #00A0C1, #00D4AA);
   box-shadow: 0 4px 12px rgba(0, 160, 193, 0.25);
}
.avatar-wrapper--video {
   background: linear-gradient(135deg, #8B5CF6, #EC4899);
   box-shadow: 0 4px 12px rgba(139, 92, 246, 0.25);
}
.avatar-img {
   width: 72px;
   height: 72px;
   border-radius: 50%;
   object-fit: cover;
   border: 3px solid #fff;
}
.avatar-initials {
   width: 72px;
   height: 72px;
   border-radius: 50%;
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 1.4rem;
   font-weight: 700;
   color: #fff;
   letter-spacing: 1px;
   border: 3px solid #fff;
}

/* --- Contact Info --- */
.contact-name {
   font-weight: 700;
   text-transform: uppercase;
   color: #1F2937;
   font-size: 0.95rem;
   letter-spacing: 0.02em;
}
.contact-role {
   color: #EC4899;
   font-weight: 600;
   font-size: 0.8rem;
   margin-bottom: 0;
}

/* --- Meta (Org & Date) --- */
.testimonial-meta {
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 2px;
   margin-top: 0.5rem;
   margin-bottom: 0.75rem;
}
.meta-org {
   font-size: 0.8rem;
   font-weight: 600;
   color: #4B5563;
}
.meta-date {
   font-size: 0.72rem;
   color: #9CA3AF;
   cursor: help;
}

/* --- Quote Preview --- */
.quote-preview {
   font-size: 0.8rem;
   color: #6B7280;
   line-height: 1.5;
   font-style: italic;
   margin-bottom: 0.75rem;
   padding: 0.5rem 0.75rem;
   background: #F9FAFB;
   border-radius: 8px;
   border-left: 3px solid #00A0C1;
   text-align: left;
   min-height: 52px;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
}
.quote-preview--video {
   border-left-color: #8B5CF6;
   color: #7C3AED;
   font-style: normal;
   font-weight: 500;
   justify-content: center;
   text-align: center;
}
.quote-mark {
   color: #00A0C1;
   font-size: 1.1rem;
   font-weight: 700;
   font-style: normal;
   line-height: 1;
}

/* --- Soft Product Tags --- */
.label-container {
   display: flex;
   flex-wrap: wrap;
   gap: 5px;
   padding-top: 0.5rem;
}
.label {
   background-color: #EDF2F7;
   color: #4A5568;
   padding: 4px 10px;
   border: 1px solid #E2E8F0;
   border-radius: 20px;
   font-size: 0.7rem;
   font-weight: 600;
   white-space: nowrap;
}
.label--overflow {
   background-color: transparent;
   border: 1px dashed #CBD5E0;
   color: #9CA3AF;
   font-weight: 500;
   cursor: default;
   position: relative;
}

/* --- Overflow Popover --- */
.overflow-trigger:hover .overflow-popover {
   display: flex;
}
.overflow-popover {
   display: none;
   position: absolute;
   bottom: calc(100% + 8px);
   left: 50%;
   transform: translateX(-50%);
   background: #fff;
   border: 1px solid #E5E7EB;
   border-radius: 10px;
   box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
   padding: 8px 10px;
   min-width: 160px;
   max-width: 260px;
   z-index: 20;
   flex-wrap: wrap;
   gap: 5px;
   justify-content: center;
}
.overflow-popover::after {
   content: '';
   position: absolute;
   top: 100%;
   left: 50%;
   transform: translateX(-50%);
   border: 6px solid transparent;
   border-top-color: #fff;
}
.overflow-popover::before {
   content: '';
   position: absolute;
   top: 100%;
   left: 50%;
   transform: translateX(-50%);
   border: 7px solid transparent;
   border-top-color: #E5E7EB;
}

/* --- Card Entrance Animation --- */
.card-stagger-enter-active,
.card-stagger-appear-active {
   animation: fadeInUp 0.4s ease both;
}
@keyframes fadeInUp {
   from {
      opacity: 0;
      transform: translateY(16px);
   }
   to {
      opacity: 1;
      transform: translateY(0);
   }
}

/* Premium Custom Checkboxes */
.custom-checkbox-input {
   position: absolute;
   opacity: 0;
   width: 0;
   height: 0;
   margin: 0;
   pointer-events: none;
}
.custom-checkbox {
   width: 20px;
   height: 20px;
   border: 2px solid #ced4da;
   border-radius: 4px;
   cursor: pointer;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   background-color: #fff;
   transition: all 0.2s ease;
   position: relative;
   flex-shrink: 0;
}
.custom-checkbox-input:checked + .custom-checkbox {
   background-color: #00A0C1;
   border-color: #00A0C1;
}
.custom-checkbox-input:checked + .custom-checkbox::after {
   content: '';
   position: absolute;
   width: 5px;
   height: 10px;
   border: solid white;
   border-width: 0 2px 2px 0;
   transform: rotate(45deg);
   top: 2px;
   left: 6px;
}
.custom-checkbox:hover {
   border-color: #00A0C1;
}
.custom-filter-dropdown-btn {
   background-color: #ffffff !important;
   color: #495057 !important;
   border: 1px solid #dee2e6 !important;
   transition: all 0.2s ease !important;
}
.custom-filter-dropdown-btn:hover,
.custom-filter-dropdown-btn:focus,
.custom-filter-dropdown-btn:active,
.custom-filter-dropdown-btn.show {
   background-color: #f8f9fa !important;
   color: #495057 !important;
   border-color: #ced4da !important;
   box-shadow: none !important;
}
.cursor-pointer {
   cursor: pointer;
}
.select-none {
   user-select: none;
}
</style>